import React from 'react';
import Layout from '../Layout';
import { useNavigate } from 'react-router-dom';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="custom-page-css flex flex-col flex-1 items-center justify-center gap-2">
        <h1>403 - Không có quyền truy cập</h1>
        <p>Bạn không có quyền xem trang này.</p>

        {/* Tuỳ chọn: liên kết quay về trang chủ */}
        <div onClick={() => navigate(-1)} className="text-blue-600 underline">
          Quay về trang trước
        </div>
      </div>
    </Layout>
  );
}

export default Unauthorized;